import RightPath from "assets/rightPath.svg";
import RightPathWhite from "assets/rightpathWhite.png";
import { useLanguage } from "LanguageContext";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Box from "ReusableComponents/Box";
import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";

const HeroOverlay = ({
  main,
  desc,
  isBooking,
  launchSlider,
  imageSliders,
  updateLaunchCompleted,
  subtitle,
  small,
  index,
}) => {
  const [hover, setHover] = useState(false);
  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");
  const [launchDate, setLaunchDate] = useState("");
  const sliderFontSize = small ? SIZES.twelve : "28px";
  const sliderSubTitleFontSize = small ? SIZES.twelve : "36px";

  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();

  const [heading, setHeading] = useState("");
  const [features, setFeatures] = useState([]);

  let interval = useRef();
  const startTimer = (date) => {
    const eventDate = new Date(date).getTime();
    interval = setInterval(() => {
      const now = new Date().getTime();
      const diff = eventDate - now;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (60 * 1000)) / 1000);

      if (diff < 0) {
        // stop timer
        clearInterval(interval?.current);

        updateLaunchCompleted(true);
      } else {
        // update timer
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };
  useEffect(() => {
    if (launchDate) {
      startTimer(launchDate);
    }
  }, [launchDate]);

  useEffect(() => {
    if (launchSlider?.attributes?.launch_date) {
      setLaunchDate(launchSlider?.attributes?.launch_date);
    }
  }, [launchSlider]);

  useEffect(() => {
    setHeading(() => imageSliders[index]?.attributes?.heading);
    setFeatures(() => {
      let features = [];
      if (imageSliders[index]?.attributes?.f1_title) {
        let f1_info = {};
        f1_info["title"] = imageSliders[index]?.attributes?.f1_title;
        f1_info["subtitle"] = imageSliders[index]?.attributes?.f1_subtitle;
        f1_info["description"] =
          imageSliders[index]?.attributes?.f1_description;
        f1_info["imgsrc"] =
          imageSliders[index]?.attributes?.f1_icon?.data?.attributes?.url;
        f1_info["imgalt"] =
          imageSliders[
            index
          ]?.attributes?.f1_icon?.data?.attributes?.alternativeText;
        features.push(f1_info);
      }
      if (imageSliders[index]?.attributes?.f2_title) {
        let f2_info = {};
        f2_info["title"] = imageSliders[index]?.attributes?.f2_title;
        f2_info["subtitle"] = imageSliders[index]?.attributes?.f2_subtitle;
        f2_info["description"] =
          imageSliders[index]?.attributes?.f2_description;
        f2_info["imgsrc"] =
          imageSliders[index]?.attributes?.f2_icon?.data?.attributes?.url;
        f2_info["imgalt"] =
          imageSliders[
            index
          ]?.attributes?.f2_icon?.data?.attributes?.alternativeText;
        features.push(f2_info);
      }
      return features;
    });
  }, [index, imageSliders]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="absolute"
      bottom="0"
      left="0"
      zIndex="2"
      h="100%"
      w="100%"
      // background="linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%)"
      justifyContent="flex-end"
      // paddingBottom={small ? "60px" : "120px"}
    >
      <Box margin={small ? "0px 50px" : "0 80px"}>
        {/* <Box marginBottom={!small && "2rem"}>
          <Box
            display="flex"
            flexDirection="column"
            position="absolute"
            top={small ? "20px" : "50px"}
            right={small ? "20px" : "250px"}
            left={small ? "30px" : "unset"}
          >
            {launchSlider ? (
              <LaunchTimer
                days={timerDays}
                minutes={timerMinutes}
                seconds={timerSeconds}
                hours={timerHours}
                small={small}
              />
            ) : null}
          </Box>

          {index <= 0 ? (
            <H1
              w="fit-content"
              display="flex"
              flexDirection="column"
              marginBottom={small ? SIZES.twelve : SIZES.twenty}
            >
              <Span
                fontSize={small ? SIZES.sizteen : SIZES.forty}
                w="fit-content"
                textAlign="center"
                textColor="white"
                background={index != 0 ? COLORS.black : COLORS.primary}
                fontWeight="bold"
                padding={small ? "0.2em" : "0.3em"}
              >
                {main}
              </Span>

              <Span
                fontSize={small ? SIZES.sizteen : SIZES.forty}
                padding={small ? "0.2em" : "0.3em"}
                background={index != 0 ? COLORS.black : COLORS.primary}
                textColor="white"
                w="fit-content"
                fontWeight="bold"
                textAlign="center"
                marginLeft="1em"
              >
                {subtitle}
              </Span>
            </H1>
          ) : (
            <H2
              w="fit-content"
              display="flex"
              flexDirection="column"
              marginBottom={small ? SIZES.twelve : SIZES.twenty}
            >
              <Span
                fontSize={small ? SIZES.sizteen : SIZES.forty}
                w="fit-content"
                textAlign="center"
                textColor="white"
                // background={index != 0 ? COLORS.black : COLORS.primary}
                fontWeight="bold"
                filter="drop-shadow(4px 4px 4px black)"
                padding={small ? "0.2em" : "0.3em"}
              >
                {main}
              </Span>

              <Span
                fontSize={small ? SIZES.sizteen : SIZES.forty}
                padding={small ? "0.2em" : "0.3em"}
                // background={index != 0 ? COLORS.black : COLORS.primary}
                textColor="white"
                w="fit-content"
                fontWeight="bold"
                filter="drop-shadow(4px 4px 4px black)"
                textAlign="center"
                marginLeft="1em"
              >
                {subtitle}
              </Span>
            </H2>
          )}
        </Box> */}

        <div className="heading">
          <ReactMarkdown children={heading} />
        </div>
        <div className="features">
          {features?.map((feature) => (
            <Box className="feature">
              <Box className="feature-icon">
                <img src={feature?.imgsrc} alt={feature?.imgalt} />
              </Box>
              <Box className="feature-text">
                <Text>{feature?.title}</Text>
                <Text>{feature?.subtitle}</Text>
                <Box className="feature-description">
                  <ReactMarkdown children={feature?.description} />
                </Box>
              </Box>
            </Box>
          ))}
        </div>

        {/* {index == 0 ? (
          <Box
            xs={{}}
            style={{
              whiteSpace: "pre-wrap",
              textAlign: "center",
            }}
            w={small ? "40%" : "298px"}
          >
            <p
              style={{
                color: COLORS.primary,
                fontFamily: "archiabold",
                fontSize: sliderFontSize,
                margin: 0,
              }}
            >
              {desc ? desc.split("\n")[0] : desc}
              <p
                style={{
                  margin: 0,
                  fontFamily: "archiabold",
                  fontSize: sliderSubTitleFontSize,
                }}
              >
                {" "}
                {desc ? desc.split("\n")[1] : desc}{" "}
              </p>
            </p>
            <p
              style={{
                color: "white",
                fontFamily: "archiabold",
                fontSize: sliderFontSize,
                margin: 0,
              }}
            >
              {desc ? desc.split("\n")[2] : desc}
            </p>
          </Box>
        ) : (
          <Box w={small ? "100%" : "298px"}>
            <Text
              fontSize={small ? SIZES.twelve : "22px"}
              textColor="white"
              margin={small && 0}
              fontWeight="bold"
            >
              {desc}
            </Text>
          </Box>
        )} */}

        {isBooking && (
          <Button
            isHover={true}
            border="none"
            // className="btn btn-primary"
            background={hover ? COLORS.black : COLORS.primary}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            display="flex"
            w={small ? "168px" : "287px"}
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            margin={small ? "20px 0 " : "36px 0 60px 0"}
            onClick={() =>
              (window.location.href = `/${selectedLanguage}/test-ride`)
            }
          >
            <Text
              fontSize={small ? SIZES.twelve : "16px"}
              fontWeight="bold"
              textColor={hover ? COLORS.white : COLORS.black}
              fontStyle="Archia"
            >
              {t("Book a Test Ride")}
            </Text>
            <img
              src={hover ? RightPathWhite : RightPath}
              alt="rightPath"
              style={{ margin: "0 8px" }}
              height="18px"
            />
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default HeroOverlay;
